import {zodObjectDocumentUpload} from '@/components/Helpers/validationHelpers.ts';
import {z} from 'zod';

export const form700Schema = () =>
    z.object({
        documents205: z.array(zodObjectDocumentUpload),
        documents400: z.array(zodObjectDocumentUpload),
        documents501: z.array(zodObjectDocumentUpload),
    });
